import React, { useState } from 'react';
import Navigation from '../components/Navigation';
import Sidebar from '../components/Sidebar';
import { Spinner } from 'react-bootstrap';
import Cookies from 'js-cookie';
import { FaDownload } from 'react-icons/fa';
import base_url from '../config/Config';
import PageLoader from '../components/PageLoader';

const EmiUpload = () => {
    const [file, setFile] = useState(null);
    const [pageLoading, setPageLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const token = Cookies.get('authToken');

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const handleUpload = async () => {
        if (!file) return alert('Please select an Excel file');

        setLoading(true);

        const formData = new FormData();
        formData.append('file', file);

        try {
            const response = await fetch(`${base_url}/api/repayment/upload-paid-sheet`, {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                body: formData,
            });

            if (response.ok) {
                alert('✅ Excel uploaded successfully');
                setFile(null);
                document.getElementById('excelInput').value = '';
            } else {
                const errorData = await response.json();
                console.error('Upload error:', errorData);
                alert('❌ Failed to upload Excel');
            }
        } catch (error) {
            console.error('Upload error:', error);
            alert('❌ Failed to upload Excel');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div className='overviewsaa'>
                <h4>Upload Paid Repayment Sheet</h4>
            </div>
            <div className='navigationss mb-5'>
                <Navigation />
            </div>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-lg-2 col-md-2 sidebarnavigartion'>
                        <div className='lmssidebar'>
                            <Sidebar />
                        </div>
                    </div>
                    <div className='col-lg-10 col-md-10'>
                        <div className='dashboardlms mt-5 text-center'>
                            <div className='row justify-content-center'>
                                <div className='col-md-4'>
                                    {/* Upload Section */}
                                    <div className=''>
                                        <label>Select Excel File</label>
                                        <input
                                            type="file"
                                            id="excelInput"
                                            className="form-control"
                                            accept=".xls,.xlsx"
                                            onChange={handleFileChange}
                                        />
                                    </div>
                                    <button
                                        className="btn btn-success mt-3"
                                        onClick={handleUpload}
                                        disabled={loading}
                                    >
                                        {loading ? <Spinner animation="border" size="sm" /> : 'Upload'}
                                    </button>

                                    {/* Download Sample Section */}
                                    <div className="mt-3">
                                        <button className="btn btn-primary">
                                            <a
                                                href="/assets/excel/PaidEMIs_FullSample.xlsx"
                                                download
                                                style={{ color: 'white', textDecoration: 'none' }}
                                            >
                                                Download Sample <FaDownload />
                                            </a>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default EmiUpload;
